interface NavItem {
  href: string
  titleKey: string
  children?: NavItem[]
  showPCNavBar?: boolean
}

export const HEADER_NAV_LINKS: NavItem[] = [
  { href: '/about', titleKey: 'navigation.about', showPCNavBar: true },
  {
    href: '/hotels',
    titleKey: 'navigation.hotels',
    showPCNavBar: true,
    children: [
      { href: '/hotels/mandala-bac-giang', titleKey: 'navigation.hotels_list.bac_giang' },
      {
        href: '/hotels/mandala-hotel-suites-hai-duong',
        titleKey: 'navigation.hotels_list.hai_duong',
      },
      { href: '/hotels/mandala-phu-yen', titleKey: 'navigation.hotels_list.phu_yen' },
      { href: '/hotels/mandala-bac-ninh', titleKey: 'navigation.hotels_list.bac_ninh' },
      { href: '/hotels/mandala-mui-ne', titleKey: 'navigation.hotels_list.mui_ne' },
      { href: '/hotels/mandala-kim-boi', titleKey: 'navigation.hotels_list.kim_boi' },
    ],
  },
  { href: '/discount', titleKey: 'navigation.discount', showPCNavBar: true },
  {
    href: '/services',
    titleKey: 'navigation.services',
    showPCNavBar: true,
    children: [
      { href: '/services/spa', titleKey: 'navigation.services_list.spa' },
      { href: '/services/pool', titleKey: 'navigation.services_list.pool' },
      { href: '/services/gym', titleKey: 'navigation.services_list.gym' },
      { href: '/services/convention-room', titleKey: 'navigation.services_list.convention' },
      { href: '/services/entertainment', titleKey: 'navigation.services_list.entertainment' },
      { href: '/services/beverage', titleKey: 'navigation.services_list.beverage' },
    ],
  },
  { href: '/contact', titleKey: 'navigation.contact', showPCNavBar: true },
  { href: '/news', titleKey: 'navigation.news', showPCNavBar: true },
  { href: '/recruit', titleKey: 'navigation.recruit' },
  { href: '/gallery', titleKey: 'navigation.gallery' },
  { href: '/members', titleKey: 'navigation.members' },
]

export function getFooterNavLinks(t: (key: string) => string) {
  return [
    { href: '/hotels', title: t('footer.hotel'), emoji: 'hotel' },
    { href: '/dining', title: t('footer.dining'), emoji: 'fork-and-knife' },
    { href: '/services', title: t('footer.services'), emoji: 'sparkles' },
    { href: '/about', title: t('footer.about'), emoji: 'information' },
    { href: '/contact', title: t('footer.contact'), emoji: 'telephone' },
  ]
}

export function getFooterLegalLinks(t: (key: string) => string) {
  return [
    { title: t('footer.bookingGuide'), href: '/booking-guide' },
    { title: t('footer.terms'), href: '/terms' },
    { title: t('footer.privacy'), href: '/privacy' },
    { title: t('footer.support'), href: 'mailto:support@mandalahotel.com.vn' },
  ]
}
